export const changeSelectedKey = (state, newKey) => {
  state.selectedKey = newKey
}

export const changeTuning = (state, tuning) => {
  state.currentHarmonica = tuning
}

export const initStore = (state, tunings) => {
  state.catalogue = tunings
  changeTuning(state, tunings[0])
}



// WEBPACK FOOTER //
// ./src/store/mutations.js